import React from 'react';
import { Link } from '@mui/material';
import { TFunction } from 'i18next';
import { OptionsObject, TransitionCloseHandler } from 'notistack';
import { ToastVariant } from './ToastVariant';

export const downloadToastOptions = (
  toastId: string,
  downloadUrl: string,
  variant: ToastVariant,
  t: TFunction,
  closeCallback: TransitionCloseHandler,
  closeSnackbar: (key?: string) => void,
) =>
  ({
    autoHideDuration: 10000,
    action: () => (
      <Link
        href={downloadUrl}
        onClick={() => closeSnackbar()}
        rel="noopener"
        target="_blank"
        underline="hover"
      >
        {t('app.download')}
      </Link>
    ),
    key: toastId,
    variant,
    preventDuplicate: true,
    onClose: closeCallback,
  } as OptionsObject);
